import { useContext } from 'react';

import type { AuthContext } from './types';

import { authContext } from './AuthContext';

export const useAuth = (): AuthContext => {
  const context = useContext(authContext);

  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return context;
};
